import { makeMutationHook } from "utils/apolloUtils";

import { CREATE_IMAGE } from "./mutations";
import { CreateImage, CreateImageVariables } from "./__generated__/CreateImage";

export const useImageCreateMutation = makeMutationHook<
  CreateImage,
  CreateImageVariables
>(CREATE_IMAGE);
